import type { StateCreator } from 'zustand';
import type { User, AuthState } from '@/types';

export interface AuthSlice {
  auth: AuthState;
  setUser: (user: User) => void;
  logout: () => void;
  updateUser: (user: User) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const createAuthSlice: StateCreator<AuthSlice, [], [], AuthSlice> = (
  set
) => ({
  auth: {
    user: null,
    isLoading: false,
    error: null,
  },

  setUser: (user) => {
    set((state) => ({
      auth: {
        ...state.auth,
        user,
        isLoading: false,
        error: null,
      },
    }));
  },

  logout: () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');

    set((state) => ({
      auth: {
        ...state.auth,
        user: null,
        isLoading: false,
        error: null,
      },
    }));
  },

  updateUser: (user) => {
    set((state) => ({
      auth: {
        ...state.auth,
        user,
      },
    }));
  },

  setLoading: (loading) => {
    set((state) => ({
      auth: {
        ...state.auth,
        isLoading: loading,
      },
    }));
  },

  setError: (error) => {
    set((state) => ({
      auth: {
        ...state.auth,
        error,
      },
    }));
  },
});
